import React, { PureComponent } from "react";
// import {Tooltip} from 'antd';
import FormCore from "@/components/display/form/formCore";
import ScGridTable from "@/components/display/table/gridTableCore";
import PropTypes from "prop-types";
// import RefreshGrid from "../../../utils/refreshGrid";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { Modal } from "antd";
// 引入组件
import ModalStruts from "./modalStruts";
// 国际化切换语言
import { powerModuleInfo } from "../../../fetch/fetchApi";

@connect((state) => state)
class ModuleList extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.moduleList;
    this.state = {
      visible: false,
      seeModuleInfoVisible: false,
      stateList: [
        {
          text: this.internationalization.state1, // '全部',
          value: "0",
        },
        {
          text: this.internationalization.state2, // '正常',
          value: "1",
        },
        {
          text: this.internationalization.state3, // '故障',
          value: "2",
        },
      ],
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.init();
  }

  init() {
    this.formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: this.internationalization.placeholder1, // '请输入模块编号',
          param: {
            name: "sn",
            type: "string",
          },
          labelName: this.internationalization.title2, // '模块编号:',
          required: false,
        },
        {
          type: "input",
          placeholder: this.internationalization.placeholder2, // '请输入设备编号',
          param: {
            name: "stubId",
            type: "string",
          },
          labelName: this.internationalization.title1, // '设备编号:',
          required: false,
        },
        {
          type: "select",
          placeholder: this.internationalization.placeholder3, // '请选择品牌',
          param: {
            name: "brand",
            type: "string",
          },

          options: [
            {
              text: this.internationalization.state1, // '全部',
              value: "",
            },
            {
              text: this.internationalization.brand1, // '台达',
              value: "0",
            },
            {
              text: this.internationalization.brand2, // '星星',
              value: "1",
            },
            {
              text: this.internationalization.brand3, // '中兴',
              value: "2",
            },
          ],

          labelName: this.internationalization.title4, // '品牌:',
          required: false,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              icon: "search",
              text: this.internationalization.btn1, // '查询'
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "grid", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      defaultParams: {},
      tableKey: "ModuleListTable",
      tablePage: "模块管理",
    };
    this.setState({
      tableConfig: {
        tableKey: "ModuleListTable",
        tableColumns: [
          {
            name: this.internationalization.title2, // '模块编号',
            key: "sn",
            colType: "textCol",
            align: "left",
          },
          {
            name: this.internationalization.title3, // '设备编号',
            key: "stubId",
            colType: "textCol",
            align: "left",
          },
          {
            name: this.internationalization.title4, // '品牌',
            colType: "textCol",
            align: "left",
            render: (value, row) => {
              const num = row.brand;
              switch (num) {
                case 0:
                  return <div>{this.internationalization.brand1}</div>;
                // break;
                case 1:
                  return <div>{this.internationalization.brand2}</div>;
                // break;
                case 2:
                  return <div>{this.internationalization.brand3}</div>;
                // break;
                default:
                  return <div>--</div>;
                // break;
              }
            },
          },
          {
            name: this.internationalization.title5, // '模块类型',
            key: "powerType",
            colType: "textCol",
            align: "left",
            render: (value, row) => {
              if (value === 0) {
                return <div>{row.power}kw</div>;
              } else if (value === 1) {
                return (
                  <div>
                    {row.power}
                    {this.internationalization.value1}
                  </div>
                );
              } else if (value === 2) {
                return (
                  <div>
                    {row.power}
                    {this.internationalization.value2}
                  </div>
                );
              } else {
                return <div>--</div>;
              }
            },
          },
          {
            name: this.internationalization.wz1, // '故障信息',
            colType: "tipCol",
            key: "msg",
            align: "left",
            // render:(value,row,index)=>{
            //     if(value != ''){
            //          const msg = row.msg.length > 10 ? (<Tooltip title= {row.msg}>
            // {row.msg.substring(0,10)+'……'}</Tooltip>) : (<div>{row.msg}</div>)
            //          return msg
            //     }else{
            //         return '--'
            //     }
            // }
          },
          {
            name: this.internationalization.wz2, // '运行时长',
            key: "runtime",
            colType: "textCol",
            align: "left",
            render: (value, row) => {
              const timeInfo = this.handleSecord(row.runtime);
              const msg = <div>{timeInfo}</div>;

              return msg;
            },
          },
          {
            name: this.internationalization.action, // '操作',
            key: "action",
            fix: "right",
            width: 100,
            colType: "action",
            actionMap: [
              {
                type: "href",
                actionName: this.internationalization.modalTitle1, // '历史设备',
                handler: (record) => {
                  // 通过查询，获取模块信息
                  this.openTab(
                    {
                      keyId: `moduleDetail`,
                      sn: record.sn,
                    },
                    {
                      key: "moduleDetail",
                      titleText: this.internationalization.modalTitle1, // '历史设备',
                    },
                  );
                },
              },
              {
                type: "href",
                actionName: this.internationalization.wz3, // '故障日志',
                handler: (record) => {
                  this.setState(
                    {
                      sn: record.sn,
                    },
                    () => {
                      // 通过查询，获取模块状态日志
                      this.modalVisibleAction("seeModuleInfoVisible", true);
                    },
                  );
                },
              },
            ],
          },
        ],
        tableChange: () => {},
        tableParam: {
          flag: "1",
        },
        dataApi: powerModuleInfo,
        autoRefresh: true, // 设置为true 直接加载grid数据
      },
    });
  }

  // 秒转换
  handleSecord(value) {
    const day = Math.floor(value / (24 * 3600)); // Math.floor()向下取整
    const hour = Math.floor((value - day * 24 * 3600) / 3600);
    const minute = Math.floor((value - day * 24 * 3600 - hour * 3600) / 60);
    const second = value - day * 24 * 3600 - hour * 3600 - minute * 60;
    if (day > 0) {
      return (
        day +
        this.internationalization.dw +
        hour +
        this.internationalization.hour +
        minute +
        this.internationalization.minute +
        second +
        this.internationalization.second
      );
    } else if (hour > 0) {
      return (
        hour +
        this.internationalization.hour +
        minute +
        this.internationalization.minute +
        second +
        this.internationalization.second
      );
    } else if (minute > 0) {
      return minute + this.internationalization.minute + second + this.internationalization.second;
    } else {
      return second + this.internationalization.second;
    }
  }

  /**
   * 开启/关闭 模态弹窗
   */
  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  /**
   * 开启新开页
   */
  openTab(param, e) {
    this.props.onAdd.bind(window.LayoutTab)(e, param);
  }

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.formConfig} />
        </div>
        <div className="page-panel">
          <ScGridTable config={this.state.tableConfig} />
        </div>

        <Modal
          title={this.internationalization.wz3}
          visible={this.state.seeModuleInfoVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => {
            this.modalVisibleAction("seeModuleInfoVisible", false);
          }}>
          <ModalStruts
            sn={this.state.sn}
            onAdd={this.props.onAdd}
            onCancel={() => {
              this.modalVisibleAction("seeModuleInfoVisible", false);
            }}
          />
        </Modal>
      </div>
    );

    return Content;
  }
}

export default injectIntl(ModuleList);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/module/moduleList.js